/**
 * 由于动态表单数据结构中rules.disableRule相关配置来表示一些此字段满足条件就不展示的逻辑
 * 所以需要写一种通用逻辑生成对应的显示与否的方法给ui赋予是否展示的逻辑判断
 */

// 一些表单控件的展现需要依赖另一些控件值
// 对外只提供此方法，需要将ui配置传入
export function genIsShowFn(item, schema = {}) {
    const disableRule = item?.rules?.disableRule || ''
    const parseDisableRule = disableRule ? JSON.parse(disableRule) : ''
    const disableRuleList = disableRule && Array.isArray(parseDisableRule) ? JSON.parse(disableRule).filter(item => item.value == 'true') : [];

    try {
        if (disableRuleList.length && disableRuleList[0]?.dependGroup) {
            item.isShowFn = _genfn(disableRuleList[0]?.dependGroup, schema)
            return item.isShowFn;
        }
    } catch (error) {
        console.log(item.name, error, '------genIsShowFn')
    }
}

// 对disableRule解析生成是否显示的方法
// 生成的方法接受form参数为整个表单的form
function _genfn({ dependExpressList, operator, dependGroupList, empty }, schema) {
    // dependExpressList 依赖的其他控件值，是个数组（可能依赖多个
    // operator 对上面dependExpressList的其他控件值做一个 与或 逻辑 值为 'and' 'or'
    // dependGroupList 暂时没遇到-不处理
    // empty 暂时也不知道此字段的用法
    // _isShowFn返回true此控件展示否则不展示（与disableRule描述达成条件相反，所以返回需要取反）
    return function _isShowFn(form) {
        if ('and' === operator) {
            // 与逻辑
            return !(dependExpressList.every((depend) => {
                return _parseDepend(depend, form, schema)
            }))
        } else if ('or' === operator) {
            // 或逻辑
            return !(dependExpressList.some((depend) => {
                return _parseDepend(depend, form, schema)
            }))
        }
        console.log('未知的disableRule操作符----', dependExpressList, '----', operator)
        return false
    }
}

// 解析dependExpressList中的单个依赖项描述
// symbol的描述：
//      is null --- fieldId指向的字段的值为空
//      == --- fieldId指向的字段的值等于value
//      != --- fieldId指向的字段的值不等于value
//      > --- fieldId指向的字段的值大于value
//      < --- fieldId指向的字段的值小于value
//      >= --- fieldId指向的字段的值大于等于value
//      <= --- fieldId指向的字段的值小于等于value
//      contains --- fieldId指向的字段的值中包含有value
//      not contains --- fieldId指向的字段的值中不包含有value
/**********************  下面这两种暂时不判断，遇到实际运用场景再对其解析  *****************************/
//      this field’s value in fieldOptions --- fieldId指向的字段的值中在fieldId对应的value列表中 
//      this field’s value not in fieldOptions --- fieldId指向的字段的值中不在fieldId对应的value列表中
function _parseDepend({ fieldId, value, symbol }, form, schema) {
    // 对于fieldId字段中含有.的进行替换为_____（5个下划线）
    let formKey = fieldId
    if (/\./.test(fieldId)) {
        formKey = fieldId.replaceAll('.', '_____')
    }
    const fieldValue = form[formKey] // 拿到当前表单对应字段的值
    // 如果依赖项不显示，则当前项也直接不显示
    if (fieldId && schema[fieldId] && schema[fieldId].isShowFn) {
        if (!schema[fieldId].isShowFn(form)) {
            return true;
        }
    }
    switch (symbol) {
        case 'is null':
            return [null, undefined, ''].includes(fieldValue)
        case '==':
            return String(fieldValue) === value
        case '!=':
            return String(fieldValue) !== value
        case '>':
            return fieldValue > value
        case '<':
            return fieldValue < value
        case '>=':
            return fieldValue >= value
        case '<=':
            return fieldValue <= value
        case 'contains':
            return (fieldValue || []).includes(value)
        case 'not contains':
            if (fieldId === 'in_prop_29029') {
            }

            return !((fieldValue || []).includes(value))
        default:
            return true
    }
}
